import { GlobalIcon } from "@hugeicons-pro/core-stroke-rounded";
import {
  Button,
  ButtonSize,
  ButtonVariant,
  IconButton,
  IconButtonSize,
  IconButtonVariant
} from "shared/components";
import { useInboxEmbed } from "../context/useInboxEmbed";
import type { TranslationLanguage } from "../types";

interface TranslateIncomingToggleProps {
  targetLanguage: TranslationLanguage;
  showingTranslation: boolean;
  isTranslating: boolean;
  onTranslate: () => void;
  onShowOriginal: () => void;
}

const labelFor = (language: TranslationLanguage): string =>
  language === "es" ? "Translate to Spanish" : "Translate to English";

export const TranslateIncomingToggle = ({
  targetLanguage,
  showingTranslation,
  isTranslating,
  onTranslate,
  onShowOriginal
}: TranslateIncomingToggleProps) => {
  const embed = useInboxEmbed();
  const label = showingTranslation ? "Show original" : labelFor(targetLanguage);
  const onClick = showingTranslation ? onShowOriginal : onTranslate;

  if (embed?.compact)
    return (
      <IconButton
        variant={IconButtonVariant.BASE}
        size={IconButtonSize.XS}
        HugeIcon={GlobalIcon}
        onClick={onClick}
        loading={isTranslating}
        disabled={isTranslating}
        borderLess
        tooltip={label}
        tooltipZIndex={embed.modalZIndex}
        aria-label={label}
      />
    );

  return (
    <Button
      variant={ButtonVariant.BASE}
      size={ButtonSize.XS}
      HugeIcon={GlobalIcon}
      onClick={onClick}
      loading={isTranslating}
      loadingMode="keep-label"
      disabled={isTranslating}
      aria-label={label}
      borderLess
    >
      {label}
    </Button>
  );
};
